// extracted by mini-css-extract-plugin
export var label = "_la-2";
export var slideContainer = "_la-0";
export var slider = "_la-1";